import React, { Component } from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { startLogin } from '../../store/actions/appstate'

import logo from '../../../images/LOGO_PATHE.png';

import SocketAPI from "../../../services/socketAPI";
import Storage from "../../../services/storage";
import popcorn from '../../../images/POPCORN_BAG.png';
import Config from '../../../config/config';
export class DeviceHome extends Component {

	constructor(props) {
		super(props);

		this.startGame = this.startGame.bind(this);
		Storage.clear();
	}

	componentDidMount() {
		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Home',
			'page_path': '/home'
		});
	}

	startGame() {
		if (this.props.roomCode.isHardcoded) {
			SocketAPI.joinQuiz(this.props.roomCode.code);
		}
		this.props.startLogin()
		this.props.history.push('login');
	}

	render() {
		const buttonClass = "btn btn-block btn-warning btn-lg";
			return(
				<div className="container">
					<div className="logo" ><img src={logo} width="100%" alt="logo" /></div>
					WELKOM!<br/><br/>
					<div className="ikdoemee">
							<button type="button" className={buttonClass} onClick={this.startGame}>IK DOE MEE!</button>
					</div>
					<div className="popcorn"><img style={{width:"100%"}} src={popcorn} alt="popcorn" /></div>
					<div className="curtains" ></div>
				</div>
			);
	}
}
		
/**************************
 * Mapping REDUX global state to local props 
 **************************/

function mapStateToProps(state) {
    return {
		roomCode: state.login.roomCode
	}
}

function mapDispatchToProps(dispatch) {
    return {
        startLogin: bindActionCreators(startLogin, dispatch)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DeviceHome)


// WEBPACK FOOTER //
// ./src/components/pages/Home/Home.js